import { useFormStateContext } from 'ui'
import { CampaignPromotion } from '../../typings/campaign'
import { Summary } from './Summary'
import { Alerts } from './Summary/Alerts'

export function Campaign() {
  const { form } = useFormStateContext()

  const { general, restrictions, scheduling, campaign }: CampaignPromotion =
    form.getValues()

  return (
    <>
      <Alerts>
        <Alerts.RegularRecap regular={campaign} />
        <Alerts.AffectedProducts />
      </Alerts>

      <Summary.Container>
        <Summary.Name name={general.name} />
        <Summary.Scheduling scheduling={scheduling} />
        <Summary.SalesChannels salesChannels={restrictions.salesChannels} />
        <Summary.Sellers sellers={restrictions.sellers} />
        <Summary.Audiences audiences={campaign.audiences} />
        <Summary.Regular benefit={campaign.benefit} />
        <Summary.Restrictions restrictions={restrictions} />
        <Summary.Accumulate restrictions={restrictions} />
      </Summary.Container>
    </>
  )
}
